export default __webpack_public_path__ + "static/icon-EpicComputer-e17d4a14bf1a265220cc543652ec1cb2.svg";